<template>
    <div class="ma-4">
        <v-col cols="12">
            <v-card>
                <v-card-title style="background-color: #2b3990">
                    <span class="headline white--text">{{ titleForm }}</span>
                </v-card-title>
                <v-card-text>
                    <v-form
                        ref="form"
                        lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col>
                                    <v-tooltip bottom cols="12" sm="12" md="4">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="newEmail"
                                                label="Email"
                                                v-on="on"
                                                :disabled="editEmail"
                                                :rules="emailRules"
                                            ></v-text-field>
                                        </template>
                                        <span>This will be used to sign into the account</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col v-if="userRole === 'SuperAdministrator'" cols="12" sm="12" md="4">
                                    <v-select
                                        v-model="newCompany"
                                        label="Company"
                                        :items="companies"
                                        item-text="Name"
                                        item-value="_id"
                                        multiple
                                        :rules="requiredField"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                    <v-select
                                        :items="filteredDRoles"
                                        label="Role"
                                        v-model="newRole"
                                        :rules="requiredField"
                                    ></v-select>
                                </v-col>
                                <!-- <v-col cols="12" sm="12" md="6"
                                        v-if="newRole === 'House Manager' || newRole === 'Assistant Manager'">
                                    <v-select
                                        v-model="newHouseManaged"
                                        label="Program Assigned to Manage"
                                        :items="programs"
                                        item-text="Name"
                                        item-value="Name"
                                        multiple
                                        :rules="requiredField"
                                    ></v-select>
                                </v-col> -->
                                <v-col cols="12" sm="12" md="3">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="newName"
                                                label="Employee Name"
                                                :rules="requiredField"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <span>The name of the employee for this account.</span>
                                    </v-tooltip>
                                </v-col>

                                <v-col cols="12" sm="12" md="3"> 
                                    <v-text-field
                                        label="Full Legal Name"
                                        v-model="newLegalName"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12" md="6" v-if="newUser">
                                        <v-text-field
                                            v-model="newPassword"
                                            type="password"
                                            label="Password"
                                            :rules="requiredField"
                                        ></v-text-field>
                                        
                                        <!-- Password strength indicator -->
                                        <div v-if="newPassword" class="mt-2">
                                            <v-progress-linear
                                                :value="passwordStrengthScore * 20"
                                                :color="passwordStrengthColor"
                                                height="8"
                                                rounded
                                            ></v-progress-linear>
                                            <div class="text-caption mt-1" :class="`${passwordStrengthColor}--text`">
                                                {{ passwordStrengthMessage }}
                                            </div>
                                        </div>
                                        
                                        <!-- Password requirements -->
                                        <v-card v-if="newPassword" class="mt-2 pa-2" outlined>
                                            <div class="text-caption font-weight-bold mb-1">Password Requirements:</div>
                                            <div class="text-caption" :class="passwordRequirements.length ? 'green--text' : 'red--text'">
                                                ✓ At least 8 characters
                                            </div>
                                            <div class="text-caption" :class="passwordRequirements.uppercase ? 'green--text' : 'red--text'">
                                                ✓ At least one uppercase letter (A-Z)
                                            </div>
                                            <div class="text-caption" :class="passwordRequirements.lowercase ? 'green--text' : 'red--text'">
                                                ✓ At least one lowercase letter (a-z)
                                            </div>
                                            <div class="text-caption" :class="passwordRequirements.numbers ? 'green--text' : 'red--text'">
                                                ✓ At least one number (0-9)
                                            </div>
                                            <div class="text-caption" :class="passwordRequirements.special ? 'green--text' : 'red--text'">
                                                ✓ At least one special character (!@#$%^&*)
                                            </div>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6" v-if="newUser">
                                        <v-text-field
                                            v-model="newRePass"
                                            type="password"
                                            label="Retype Password"
                                            :rules="requiredField"
                                        ></v-text-field>
                                    </v-col>
                                    
                                    <!-- Password validation message -->
                                    <v-col cols="12" v-if="newUser && passwordMatchMessage">
                                        <v-alert
                                            type="error"
                                            dense
                                            dismissible
                                        >
                                            {{ passwordMatchMessage }}
                                        </v-alert>
                                    </v-col>
                                
                                <v-col cols="12" sm="12" md="6">
                                    <DatePicker
                                        :default-date="newDate"
                                        label="Date Hired"
                                        v-model="newDate"
                                        :rules="requiredField"
                                    />
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <DatePicker
                                        :default-date="birthDate"
                                        label="Birth Date"
                                        v-model="birthDate"
                                    />
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                    <DatePicker
                                        :default-date="anniversaryDate"
                                        label="Anniversary Date"
                                        v-model="anniversaryDate"
                                    />
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                    <v-select
                                        v-model="newProgram"
                                        label="Program"
                                        :items="programs"
                                        item-text="Name"
                                        item-value="Name"
                                        multiple
                                        :rules="requiredField"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        v-model="newPhoneNumber"
                                        label="Phone Number"
                                        v-mask="'(###) ###-####'"
                                        :rules="requiredField"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        v-model="newAddress"
                                        label="Address"
                                        :rules="requiredField"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        v-model="newCity"
                                        label="City"
                                        :rules="requiredField"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-select
                                        v-model="newState"
                                        label="State"
                                        :rules="requiredField"
                                        :items="states"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        v-model="newZip"
                                        label="Zip"
                                        :rules="requiredField"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="3" v-if="!hide">
                                    <v-text-field
                                        prefix="$"
                                        v-model="newRate"
                                        label="Rate"
                                        :rules="requiredField"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="3" v-if="!hide">
                                    <v-select
                                        v-model="newRateType"
                                        label="Rate per"
                                        :items="['hour', 'year']"
                                        :rules="requiredField"
                                    ></v-select>
                                </v-col>
                                <!-- <v-col cols="12" sm="12" md="4" v-if="!hide">
                                    <v-text-field
                                        prefix="$"
                                        v-model="newRaise"
                                        label="Raise"
                                    ></v-text-field>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="4" v-if="!hide">
                                    <DatePicker
                                        :default-date="newRaiseDate"
                                        label="Raise Date"
                                        v-model="newRaiseDate"
                                    />
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="12">
                                    <template>
                                        <v-data-table
                                            :headers="headersForSalary"
                                            :items="userSelectedSalaryHistory"
                                            class="elevation-1"
                                        ></v-data-table>
                                    </template>
                                </v-col> -->
                                <v-col class="d-flex" cols="12" sm="6">
                                    <v-autocomplete
                                        :items="estatus"
                                        outlined
                                        label="Status"
                                        v-model="newStatus"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col class="d-flex" cols="12" md="6">
                                    <v-text-field
                                        label="Payroll ID"
                                        outlined
                                        v-model="newPaychexID"
                                    ></v-text-field>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="4" v-if="newStatus === 'Terminated'">
                                    <DatePicker
                                        :default-date="newTerminationDate"
                                        label="Termination Date"
                                        v-model="newTerminationDate"
                                    />
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="4" v-if="newStatus === 'Terminated'">
                                    <DatePicker
                                        :default-date="newReHireDate"
                                        label="Re-Hire Date"
                                        v-model="newReHireDate"
                                    />
                                </v-col>
                                <v-col cols="12" v-if="newStatus ==='Terminated'">
                                    <v-textarea
                                        label="Termination Reason"
                                        v-model="newTerminationReason"
                                        outlined
                                        :rules="requiredField"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" v-if="newStatus ==='Terminated'">
                                    <v-file-input
                                        label="Termination Documentation"
                                        v-model="newTerminationDocumentation"
                                        multiple
                                    ></v-file-input>
                                    <v-col cols="12" v-if="newStatus ==='Terminated'">
                                        <v-col cols="12" sm="12" md="12"
                                               v-for="(document, index) in newTerminationDocumentation"
                                               :key="index">
                                            <template v-if="document.type === 'pdf'">
                                                <LoadPDF :pdfFile="document.url" :pdfName="document.name"/>
                                            </template>
                                            <template v-else-if="['jpg', 'jpeg', 'png'].includes(document.type)">
                                                <img :src="document.url" alt="" width="320" height="240">
                                            </template>
                                            <template v-else-if="['doc', 'docx'].includes(document.type)">
                                                <VueDocPreview :value="document" :type="'office'" width="500"/>
                                            </template>
                                            <v-icon @click="removeImage(index)" title="Remove Document">mdi-delete
                                            </v-icon>
                                            <v-icon @click="downloadDocument(document)" title="Download Document">
                                                mdi-download
                                            </v-icon>
                                        </v-col>
                                    </v-col>
                                </v-col>
                                <v-row class="ml-1">
                                <v-col cols="12" md="3">
                                    <v-switch
                                        label="Med Certified"
                                        v-model="newMedCertified"
                                        hide-details
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-switch
                                        label="First Aid"
                                        v-model="newFirstAid"
                                        hide-details
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-switch
                                        label="Certified Intervention Training"
                                        v-model="newSafetyCare"
                                        hide-details
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-switch
                                        label="Certified Driver"
                                        v-model="newCertifiedDriver"
                                        hide-details
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-switch
                                        label="Human Rights Committee Member"
                                        v-model="HRCMember"
                                        hide-details
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-switch
                                        label="Completed Food Handler's Course"
                                        v-model="completedFHC"
                                        hide-details
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-switch
                                        label="QIDP"
                                        v-model="QIDP"
                                        hide-details
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-switch
                                        label="Bachelors Degree"
                                        v-model="BachelorsDegree"
                                        hide-details
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-switch
                                        label="Vocational Rehab"
                                        v-model="VocRehab"
                                        hide-details
                                    ></v-switch>
                                </v-col>
                               
                                <!-- <v-col cols="12" sm="12" md="4">
                                    <v-select
                                        :items="users"
                                        item-text="Name"
                                        item-value="Name"
                                        label="Referrals"
                                        v-model="newReferrals"
                                    ></v-select>
                                </v-col> -->

                                <v-col cols="12" sm="12" md="3">
                                    <v-switch
                                        label="Requires Supervision"
                                        v-model="requiresSupervision"
                                    ></v-switch>
                                    
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                    <v-switch
                                        label="Set Geofencing"
                                        v-model="setGeofencing"
                                    ></v-switch>
                                </v-col>

                            </v-row>


                                <v-col cols="12" sm="12" md="6" v-if="!newUser">
                                    <img :src="userSignatureImgSrc" alt="User Signature" v-if="userSignatureImgSrc"
                                         height="125"/>
                                </v-col>

                                <v-col cols="12" sm="12" md="6" v-if="newUser">
                                    <img :src="userInitialsImgSrc" alt="User Initials" v-if="userInitialsImgSrc"
                                         height="125"/>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="#259647" class="white--text" @click="addAccount()"
                           v-if="newUser">Save
                    </v-btn>
                    <v-btn color="#259647" class="white--text" @click="updateAccount()"
                           v-if="!newUser">Update
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
        <Foot/>
    </div>
</template>

<script>
import axios from 'axios'
import Foot from '../components/Footer'
import moment from "moment";
import Swal from 'sweetalert2'
import LoadPDF from '@/components/LoadPDF.vue'
import VueDocPreview from 'vue-doc-preview'
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";
import DateTimeUtil from "../../utils/date-time.util";


import {mapState} from "vuex";

const url = require("../client_config/config").url;

export default {
    components: {
        LoadPDF,
        Foot,
        DatePicker,
        VueDocPreview
    },
    data: function () {
        return {
            tab: null,
            items: ["Active Users", "Former Users"],
            userSelectedSalaryHistory: [],
            msg: false,
            editEmail: false,
            hide: false,
            search: "",
            text: "",
            newName: "",
            newLegalName: "",
            newEmail: "",
            newPassword: "",
            newRePass: "",
            newRole: "",
            birthMenu: false,
            anniversaryMenu: false,
            activePicker: null,
            birthDate: null,
            anniversaryDate: null,
            position: ["Admin", "House Manager", "Assistant Manager", "Direct Care Staff"],
            estatus: ["Full-Time", "Part-Time", "Terminated"],
            states: ["Utah", "Nevada"],
            carriers: [
                "AT&T",
                "Boost Mobile",
                "Cricket",
                "Metro PCS",
                "Sprint",
                "Straight Talk",
                "T-Mobile",
                "Verizon",
                "Virgin Mobile"],
            newDate: "",
            newProgram: [],
            newPhoneNumber: "",
            newPhoneCarrier: "",
            newAddress: "",
            newCity: "",
            newState: "",
            newZip: "",
            newRate: "",
            newRateType: "",
            newRaise: "",
            newRaiseDate: "",
            newTerminationDate: "",
            newTerminationReason: "",
            newTerminationDocumentation: [],
            newHouseManaged: [],
            newAnnualReview: "",
            newPosition: "",
            newStatus: "",
            newReHireDate: "",
            newMedCertified: false,
            newFirstAid: false,
            newSafetyCare: false,
            newCertifiedDriver: false,
            newSecurityQuestion: "",
            client: "",
            clients: [],
            programs: [],
            // newAnswer: "",
            emailRules: [
                v => !!v || 'This is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            requiredField: [
                v => (v && v.length > 0) || 'This is required',
            ],
            headers: [
                {
                    text: "Name",
                    align: "start",
                    sortable: false,
                    value: "Name",
                },
                {text: "Email", value: "Email"},
                // { text: "Company", value: "CompanyID" },
                {text: "Role", value: "Role"},
                {text: "Progress", value: "Progress"},
                {text: "Verification Status", value: "VerificationStatus"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            headersForSalary: [
                {
                    text: "Rate",
                    align: "start",
                    sortable: false,
                    value: "Rate",
                },
                {text: "Raise", value: "Raise"},
                {text: "RaiseDate", value: "RaiseDate"},
            ],
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            menu2: false,
            menu3: false,
            menu4: false,
            menu5: false,
            menu6: false,
            menu7: false,
            menu8: false,
            menu9: false,
            users: [],
            former: [],
            temp: [],
            titleForm: "New Account",
            userID: this.$route.params.id,
            HRCMember: false,
            ShiftLead: false,
            newReferrals: '',
            newPaychexID: '',
            userState: localStorage.getItem('userState'),
            isLoading: false,
            companies: [],
            newCompany: [],
            terminationStatus: "",
            newStaffSignature: null,
            showSignaturePad: true,
            userSignatureImgSrc: null,
            userInitialsImgSrc: null,
            userRole: localStorage.getItem('userRole'),
            birthDateMenu: false,
            anniversaryDateMenu: false,
            QIDP: false,
            BachelorsDegree: false,
            VocRehab: false,
            requiresSupervision: false,
            newUser: false,
            completedFHC: false,
            setGeofencing: false,
        };
    },

    computed: {
        filteredDRoles() {
            const userRole = localStorage.getItem('userRole');
            if (userRole !== 'SuperAdministrator') {
                return this.droles.filter((drole) => {
                    return drole !== 'SuperAdministrator'
                })
            }
            return this.droles;

        },

        // Password validation message
        passwordMatchMessage() {
            if (this.newPassword && this.newRePass) {
                return this.newPassword === this.newRePass ? '' : 'Passwords do not match';
            }
            return '';
        },

        // Password strength properties
        passwordRequirements() {
            return this.newPassword ? this.validatePasswordStrength(this.newPassword) : {
                length: false,
                uppercase: false,
                lowercase: false,
                numbers: false,
                special: false
            };
        },

        passwordStrengthMessage() {
            return this.newPassword ? this.getPasswordStrengthMessage(this.newPassword) : '';
        },

        passwordStrengthColor() {
            return this.newPassword ? this.getPasswordStrengthColor(this.newPassword) : 'grey';
        },

        passwordStrengthScore() {
            return this.newPassword ? this.getPasswordStrengthScore(this.newPassword) : 0;
        },

        ...mapState({
            droles: 'userRoles',
        })

    },

    watch: {
        birthMenu(val) {
            val && setTimeout(() => (this.activePicker = 'YEAR'))
        },
        anniversaryMenu(val) {
            val && setTimeout(() => (this.activePicker = 'YEAR'))
        },
    },

    created() {

        this.newUser = this.$route.query.newUser === 'true';

        this.getPrograms();
        this.getClients();
        this.getCompanies();
    },

    mounted() {
        if (!this.newUser) {
            this.getUser();
        }
    },


    methods: {

        // Password comparison function
        checkPasswordMatch() {
            if (this.newPassword && this.newRePass) {
                return this.newPassword === this.newRePass;
            }
            return false;
        },

        // Password strength validation
        validatePasswordStrength(password) {
            const requirements = {
                length: password.length >= 8,
                uppercase: /[A-Z]/.test(password),
                lowercase: /[a-z]/.test(password),
                numbers: /[0-9]/.test(password),
                special: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)
            };
            
            return requirements;
        },

        // Get password strength score (0-4)
        getPasswordStrengthScore(password) {
            if (!password) return 0;
            
            const requirements = this.validatePasswordStrength(password);
            return Object.values(requirements).filter(Boolean).length;
        },

        // Get password strength message
        getPasswordStrengthMessage(password) {
            if (!password) return '';
            
            const score = this.getPasswordStrengthScore(password);
            
            if (score === 5) return 'Strong password';
            if (score === 4) return 'Good password';
            if (score === 3) return 'Fair password';
            if (score === 2) return 'Weak password';
            if (score === 1) return 'Very weak password';
            return 'Invalid password';
        },

        // Get password strength color
        getPasswordStrengthColor(password) {
            const score = this.getPasswordStrengthScore(password);
            
            if (score === 5) return 'success';
            if (score === 4) return 'info';
            if (score === 3) return 'warning';
            if (score <= 2) return 'error';
            return 'grey';
        },

        signatureData(data) {
            this.newStaffSignature = data;
        },

        getColor(sts) {
            console.log({sts});
            if (sts === "New") return 'green'
            else if (sts === "Prospect") return 'orange'
            else if (sts === "Negotion") return 'blue'
            else return 'teal'
        },

        validate() {
            return this.$refs.form.validate();
        },

        validateReset() {
            if (this.$refs.form !== undefined) {
                this.$refs.form.reset();
            }
        },

        initialize() {
            this.users = [];
            this.companies = [];
            this.newCompany = [];
        },

        showAdd() {
            this.titleForm = "New Account";
            this.adddialog = true;
            this.editEmail = false;
            this.newName = "";
            this.newLegalName = "";
            this.newEmail = "";
            this.newPassword = "";
            this.newRePass = "";
            this.newRole = "Direct Care Staff";
            this.client = "";
            this.newDate = "";
            this.newProgram = "";
            this.newPhoneNumber = "";
            this.newPhoneCarrier = "";
            this.newAddress = "";
            this.newSecurityQuestion = "";
            this.newCity = "";
            this.newState = "";
            this.newZip = "";
            this.newRate = "";
            this.newRateType = "";
            this.newRaise = "";
            this.newRaiseDate = "";
            this.newAnnualReview = "";
            this.newPosition = "";
            this.newStatus = "";
            this.newMedCertified = false;
            this.newFirstAid = false;
            this.newSafetyCare = false;
            this.newCertifiedDriver = false;
            this.HRCMember = false;
            this.ShiftLead = false;
            this.newTerminationDate = "";
            this.newTerminationReason = "";
            this.newTerminationDocumentation = [];
            this.newHouseManaged = [];
            this.newReHireDate = "";
            this.newPaychexID = "";
            this.QIDP = false;
            this.BachelorsDegree = false;
            this.VocRehab = false;
            this.completedFHC = false;
            // this.newAnswer = "";
            this.validateReset();
        },


        editAccount(item) {
            this.userID = item._id;
            this.titleForm = "Edit Account";
            this.newPassword = item.Password;
            this.newRePass = item.Password;
            this.newEmail = item.Email;
            this.newName = item.Name;
            this.newLegalName = item.LegalName;
            this.newRole = item.Role;
            this.newProgram = item.Program;
            this.newPhoneNumber = item.PhoneNumber;
            this.newPhoneCarrier = item.PhoneCarrier;
            this.newAddress = item.Address;
            this.newSecurityQuestion = item.SecurityQuestion;
            this.newCity = item.City;
            this.newState = item.State;
            this.newZip = item.Zip;
            this.newAnnualReview = item.AnnualReview;
            this.newRate = item.Rate;
            this.newRateType = item.RateType;
            // this.newRaise = item.Raise;
            // this.newRaiseDate = item.RaiseDate;
            this.newPosition = item.Position;
            this.newStatus = item.Status;
            this.newMedCertified = item.MedCertified;
            this.newFirstAid = item.FirstAid
            this.newSafetyCare = item.SafetyCare;
            this.newCertifiedDriver = item.CertifiedDriver;
            this.HRCMember = item.HRCMember;
            this.ShiftLead = item.ShiftLead;
            this.newTerminationDate = item.TerminationDate;
            this.newTerminationReason = item.TerminationReason;
            this.newHouseManaged = item.HouseManaged;
            this.newReHireDate = item.ReHireDate;
            this.newPaychexID = item.PaychexID;
            this.newCompany = item.Company;
            this.userSignatureImgSrc = item.Signature;
            this.userInitialsImgSrc = item.Initials;
            this.QIDP = item.QIDP;
            this.BachelorsDegree = item.BachelorsDegree;
            this.VocRehab = item.VocRehab;
            this.requiresSupervision = item.RequiresSupervision;
            this.completedFHC = item.CompletedFHC;
            this.setGeofencing= item.SetGeofencing;

            if (item.Date) {
                this.newDate = moment(item.Date).format("YYYY-MM-DD");
            } else {
                this.newDate = ''
            }

            if (item.BirthDate) {
                this.birthDate = moment(item.BirthDate).format("YYYY-MM-DD");
            } else {
                this.birthDate = ''
            }

            if (item.AnniversaryDate) {
                this.anniversaryDate = moment(item.AnniversaryDate).format("YYYY-MM-DD");
            } else {
                this.anniversaryDate = moment(item.Date).format("YYYY-MM-DD");
            }

            // this.newAnswer = item.Answer;

            this.terminationStatus = item.Status

            let documents = [];

            if (item.Document != null) {
                documents = Array.isArray(item.Document) ? item.Document : [item.Document];
            }

            if (documents && documents.length > 0) {
                this.newTerminationDocumentation = documents.map(document => {
                    return {
                        name: document.Name,
                        url: document.AWSLink,
                        type: document.AWSLink.split('.').pop()
                    };
                });
            }


            axios.get(`${url}/users/allSalaryOfUsers`).then((res) => {
                const AccountTobeUpdated = res.data.users;
                AccountTobeUpdated.forEach(usersalary => {
                    if (usersalary.Email === item.Email) {
                        this.userSelectedSalaryHistory.push(usersalary);
                        this.deleteDuplicates(item.Email);
                    }
                });
            }).finally(() => this.isLoading = false);
        },

        changePassword(item) {
            this.passdialog = true;
            this.userID = item._id;
        },

        deleteDuplicates(email) {
            this.userSelectedSalaryHistory = this.userSelectedSalaryHistory.filter((item, index, self) =>
                index === self.findIndex(t => t._id === item._id)
            );


            this.userSelectedSalaryHistory = this.userSelectedSalaryHistory.map(item => {
                const convertedDate = item.RaiseDate ? DateTimeUtil.toLocalDate(item.RaiseDate) : item.RaiseDate;
                return {
                    ...item,
                    RaiseDate: convertedDate
                };
            });

            this.userSelectedSalaryHistory = this.userSelectedSalaryHistory.filter((item, index, self) =>
                index === self.findIndex(t => t.Raise === item.Raise && t.Rate === item.Rate && t.RaiseDate === item.RaiseDate)
            );

            // Filter the list to only include items with the specified email
            this.userSelectedSalaryHistory = this.userSelectedSalaryHistory.filter(item => item.Email === email);
        },

        addUserSalaryRaiseUpdate() {
            this.isLoading = true;
            let req_body = {
                Email: this.newEmail,
                Rate: this.newRate,
                Raise: this.newRaise,
                RaiseDate: this.newRaiseDate
            };
            axios.post(`${url}/users/userSalaryRaised`, req_body).then(response => {
                if (response.status === 400) {
                    response.json().then(function (data) {
                        this.msg = true;
                        this.text = data.msg;
                    });
                }
            }).finally(() => this.isLoading = false);
        },

        close() {
            this.clear();
            this.$router.push({path: '/Users'});
        },

        async updateAccount() {
            this.isLoading = true
            if (this.validate()) {
                let req_body = {
                    Name: this.newName,
                    LegalName: this.newLegalName,
                    Email: this.newEmail,
                    Role: this.newRole,
                    Date: this.newDate,
                    BirthDate: this.birthDate,
                    AnniversaryDate: this.anniversaryDate,
                    Program: this.newProgram,
                    PhoneNumber: this.newPhoneNumber,
                    PhoneCarrier: this.newPhoneCarrier,
                    Address: this.newAddress,
                    SecurityQuestion: this.newSecurityQuestion,
                    // Answer: this.newAnswer,
                    City: this.newCity,
                    State: this.newState,
                    Zip: this.newZip,
                    AnnualReview: this.newAnnualReview,
                    Rate: this.newRate,
                    RateType: this.newRateType,
                    // Raise: this.newRaise,
                    // RaiseDate: this.newRaiseDate,
                    Position: this.newPosition,
                    Status: this.newStatus,
                    MedCertified: this.newMedCertified,
                    FirstAid: this.newFirstAid,
                    SafetyCare: this.newSafetyCare,
                    CertifiedDriver: this.newCertifiedDriver,
                    HRCMember: this.HRCMember,
                    ShiftLead: this.ShiftLead,
                    TerminationDate: this.newTerminationDate,
                    TerminationReason: this.newTerminationReason,
                    HouseManaged: this.newHouseManaged,
                    ReHireDate: this.newReHireDate,
                    PaychexID: this.newPaychexID,
                    UrlNotification: this.$router.history.current.path,
                    Company: this.newCompany,
                    Signature: this.newStaffSignature,
                    QIDP: this.QIDP,
                    BachelorsDegree: this.BachelorsDegree,
                    VocRehab: this.VocRehab,
                    RequiresSupervision: this.requiresSupervision,
                    CompletedFHC: this.completedFHC,
                    SetGeofencing: this.setGeofencing,
                };

                // this.addUserSalaryRaiseUpdate();
                try {
                    Swal.fire({
                        title: 'Please wait...',
                        text: 'Updating the user...',
                        icon: 'info',
                        allowOutsideClick: false,
                        showConfirmButton: false,
                        willOpen: () => {
                            Swal.showLoading();
                        },
                    });

                    const response = await axios.put(`${url}/users/${this.userID}`, req_body);

                    // const uploadAlert = Swal.fire({
                    //     title: 'Uploading files...',
                    //     showConfirmButton: false,
                    //     allowOutsideClick: false
                    // });


                    if (this.newStatus === 'Terminated') {
                        await this.uploadFiles();
                    }

                    // uploadAlert.close();

                    if (response.status === 400) {
                        const {msg} = await response.data;
                        this.msg = true;
                        this.text = msg;
                    } else {
                        Swal.fire({
                            title: 'Success!',
                            text: 'The account details have been updated successfully.',
                            icon: 'success'
                        });
                    }
                } catch (error) {
                    console.error(error);
                    this.text = "An error occurred while updating the account details.";
                    this.msg = true;
                }

                this.isLoading = false;
                this.close();
            } else {
                Swal.fire({
                    title: 'Missing Information',
                    text: 'Ensure all mandatory fields are filled in.',
                    icon: 'error'
                });
            }
        },

        getPrograms() {
            if (localStorage.getItem('userRole') === 'Administration') {
                axios.get(`${url}/units/?company=${localStorage.getItem("userCompanies")}}`).then(async res => {
                    this.programs = []
                    this.programs = res.data.units
                })
            } else {
                axios.get(`${url}/units/state/${this.userState}`).then(async res => {
                    this.programs = []
                    this.programs = res.data.units
                })
            }

        },

        getCompanies: function () {
            this.isLoading = true;
            axios.get(`${url}/companies`).then(res => {
                this.companies = res.data.companies;
            }).finally(() => this.isLoading = false);
        },

        async addAccount() {
            if (this.validate()) {
                if (this.newPassword === this.newRePass) {
                    let req_body = {
                        Name: this.newName,
                        LegalName: this.newLegalName,
                        Email: this.newEmail,
                        Password: this.newPassword,
                        Role: this.newRole,
                        ClientID: this.client,
                        Date: this.newDate,
                        Program: this.newProgram,
                        PhoneNumber: this.newPhoneNumber,
                        PhoneCarrier: this.newPhoneCarrier,
                        Address: this.newAddress,
                        SecurityQuestion: this.newSecurityQuestion,
                        City: this.newCity,
                        State: this.newState,
                        Zip: this.newZip,
                        AnnualReview: this.newAnnualReview,
                        Rate: this.newRate,
                        RateType: this.newRateType,
                        // Raise: this.newRaise,
                        AnniversaryDate: this.anniversaryDate,
                        BirthDate: this.birthDate,
                        // RaiseDate: this.newRaiseDate,
                        Position: this.newPosition,
                        Status: this.newStatus,
                        MedCertified: this.newMedCertified,
                        FirstAid: this.newFirstAid,
                        SafetyCare: this.newSafetyCare,
                        CertifiedDriver: this.newCertifiedDriver,
                        TerminationDate: this.newTerminationDate,
                        TerminationReason: this.newTerminationReason,
                        HouseManaged: this.newHouseManaged,
                        ReHireDate: this.newReHireDate,
                        HRCMember: this.HRCMember,
                        ShiftLead: this.ShiftLead,
                        PaychexID: this.newPaychexID,
                        UrlNotification: this.$router.history.current.path,
                        Company: this.newCompany,
                        Signature: this.newStaffSignature,
                        QIDP: this.QIDP,
                        BachelorsDegree: this.BachelorsDegree,
                        VocRehab: this.VocRehab,
                        RequiresSupervision: this.requiresSupervision,
                        CompletedFHC: this.completedFHC,
                        SetGeofencing: this.setGeofencing,
                    };

                    try {
                        Swal.fire({
                            title: 'Please wait...',
                            text: 'Saving new user...',
                            icon: 'info',
                            allowOutsideClick: false,
                            showConfirmButton: false,
                            willOpen: () => {
                                Swal.showLoading();
                            },
                        });

                        const response = await axios.post(`${url}/users`, req_body);
                        if (!response.data.success) {
                            Swal.fire({
                                icon: 'error',
                                title: 'Oops...',
                                text: response.data.message,
                            });
                            return;
                        }
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: "The new user has been added successfully.",
                        }).then((result) => {
                            if (result.value) {
                                this.close();
                            }
                        });
                    } catch (error) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: error.response ? error.response.data.message : 'Something went wrong!',
                        });
                    }


                }
            }
        },

        updatePassword() {
            if (this.validate()) {
                if (this.newPassword === this.newRePass) {
                    let req_body = {
                        password: this.newPassword
                    };
                    axios.put(`${url}/users/${this.userID}/update-password`, req_body).then((response) => {
                        if (response.status === 400) {
                            response.json().then(function (data) {
                                this.msg = true;
                                this.text = data.msg;
                            });
                        } else {
                            this.text = "The account password has been updated successfully.";
                            this.msg = true;
                            this.close();
                        }
                    });
                } else {
                    this.text = "The passwords do not match, please try again.";
                    this.msg = true;
                }
            }
        },


        viewUser(data) {
            this.$router.push({name: 'NewHirePortal', params: {empID: data._id}})
        },

        getClients() {
            this.isLoading = true;
            axios.get(`${url}/clients`).then((response) => {
                this.clients = response.data.clients;
            }).finally(() => this.isLoading = false);
        },

        checkClient() {
            this.hide = this.newRole === 'Client';
            return this.hide;
        },

        checkDate(date) {
            let isDateValid = isNaN(Date.parse(date));
            if (isDateValid) {
                return date = ""
            }
            return moment(date).format('YYYY-MM-DD')
        },

        async uploadFiles() {
            const formData = new FormData();

            for (let i = 0; i < this.newTerminationDocumentation.length; i++) {
                formData.append("files", this.newTerminationDocumentation[i]);
            }

            try {
                await axios.post(`${url}/users/fileUpload/${this.userID}`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                this.newTerminationDocumentation = [];

            } catch (error) {
                console.error(error);
                this.text = "An error occurred while uploading the files.";
                this.msg = true;
            }
        },

        removeImage(index) {

            axios.delete(`${url}/users/${this.userID}/document/${index}`)
                .then(() => {
                    Swal.fire({
                        title: 'Document successfully deleted!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            location.reload();
                        }
                    });
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        downloadDocument(url) {
            if (url) {
                window.open(url, '_blank');
            } else {
                alert('No documents available');
            }
        },

        getUser() {
            axios.get(`${url}/users/${this.userID}`).then(response => {
                this.user = response.data.user;
                this.editAccount(this.user);
            }).catch(error => {
                console.error('Error fetching user:', error);
            });
        },


        clear() {
            this.newName = "";
            this.newLegalName = "";
            this.newEmail = "";
            this.newPassword = "";
            this.newRePass = "";
            this.newRole = "Direct Care Staff";
            this.client = "";
            this.newDate = "";
            this.birthDate = "";
            this.anniversaryDate = "";
            this.newProgram = [];
            this.newPhoneNumber = "";
            this.newPhoneCarrier = "";
            this.newAddress = "";
            this.newSecurityQuestion = "";
            this.newCity = "";
            this.newState = "";
            this.newZip = "";
            this.newAnnualReview = "";
            this.newRate = "";
            this.newRaise = "";
            this.newRaiseRate = "";
            this.newPosition = "";
            this.newStatus = "";
            this.newMedCertified = "";
            this.newFirstAid = "";
            this.newSafetyCare = "";
            this.newCertifiedDriver = "";
            this.newTerminationDate = "";
            this.newTerminationReason = "";
            this.newTerminationDocumentation = "";
            this.newHouseManaged = [];
            this.newReHireDate = "";
            this.newPaychexID = "";
            this.HRCMember = false;
            this.ShiftLead = false;
            this.newCompany = [];
            this.QIDP = false;
            this.BachelorsDegree = false;
            this.VocRehab = false;
            this.requiresSupervision = false;
            this.completedFHC = false;
            this.setGeofencing = false;
            // this.newAnswer="";

        }

    },
};
</script>

<style>

.red-header {
    color: red;
}

* {
    text-decoration: none;
}
</style>
